import { graphql } from "src/gql/graphql";

export const WorkspaceGlobalsFragment = graphql(
  `
  fragment WorkspaceGlobals on Workspace @_unmask {
    id
    isKarteActivated
    isReviewsActivated
    zoomConnectionAvailable
    eventDestinationAvailable
    torqeeConnectionAvailable
    transcriptVisibilityRestrictionEnabled
    phoneMappingEnabled
  }
`,
);

export type ValidatedWorkspaceGlobals = {
  id: string;
  transcriptVisibilityRestrictionEnabled: boolean;
  isKarteActivated: boolean;
  isReviewsActivated: boolean;
  zoomConnectionAvailable: boolean;
  torqeeConnectionAvailable: boolean;
  eventDestinationAvailable: boolean;
};
